import { useState } from 'react';
import { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  makeStyles,
  Box
} from "@material-ui/core";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { Theme } from "@material-ui/core/styles";
import { withStyles } from '@material-ui/core';
import { SupportFile } from '../../../../../../store';
import { UploadDocuments } from '../../../../../../api/PE_API';
import { useParams } from 'react-router-dom';
import CameraLib from './CameraLib';

// Update log
// FB  6192   02/06/2023  DK  Added for QR code image upload
// FB  6925   06/06/2023  KK  Upload Doc (Use smartphone)> Updating the QR code with the Dynamic Link

export default function CameraComponent(props: any) {
  var doc_type = "";
  var encodedAppt_n = "";
  var decodedAppt_n = "";
  const { apptId } = useParams();
  if (apptId != undefined) {
  // FB 6925 KK BEGIN
  //  encodedAppt_n = apptId;
  // decodedAppt_n = Buffer.from(encodedAppt_n, "base64").toString();
   decodedAppt_n = apptId; 
  // FB 6925 KK END
  }

  const { docType } = useParams();
  if (docType != undefined) {
    doc_type = Buffer.from(docType, "base64").toString();
  }

  const [inputList, setInputList] = useState<SupportFile[]>([]);
  const [base64Img, setBase64Img] = useState("");
  const [capturedImage, setCapturedImage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    }
  })
  const classes = useStyles();
  const handleClose = async () => {
    setOpenDialog(false);
  };
  const DialogActions = withStyles((theme: Theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);
  const uploadImage = async (file: any) => {
    const formData = new FormData();
    formData.append("file", file);
  };

  useEffect(() => {
    async function upload() {
      if (base64Img != "") {
        const input = {
          DocumentType: doc_type,
          OtherDocument: '',
          FileName: Number(decodedAppt_n) + '.png',
          FileType: 'image/png',
          FileSize: 0,
          Base64EncodedFile: base64Img,
          Appointment_N: Number(decodedAppt_n)
        } as SupportFile;
        inputList.push(input);
        const result = await UploadDocuments(inputList, Number(decodedAppt_n));
        if (result === 200) {
          setOpenDialog(true);
          setCapturedImage("saved");
          setInputList([]);
        }
      }
    }
    upload();
  }, [base64Img]);


  return (
    <Box
      sx={{
        width: "100%",
        padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
      }}
    >
      <div className="App">
        <p>Capture image from your camera!!</p>
        <CameraLib sendFile={uploadImage} callBack={setBase64Img} />

        <Dialog
          onClose={handleClose}
          maxWidth={"xs"}
          id="validationDialog"
          aria-labelledby="customized-dialog-title"
          open={openDialog}
        >
          <DialogContent dividers>
            <Typography style={{ fontSize: "14px" }} gutterBottom>
              File uploaded successfully!
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className={classes.active}
              onClick={handleClose}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
}
